import React, { useEffect, useState } from 'react';
import './TermsAndConditions.css';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const TermsAndConditions = () => {
    const [metaTags, setMetaTags] = useState([]);

    useEffect(() => {
        const fetchMetaTags = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}website/metaTags/terms_and_conditions`, {
                    headers: {
                        Accept: 'application/json',
                        'Client-Domain': process.env.REACT_APP_CLIENT_DOMAIN,
                    },
                });

                const htmlString = res.data?.metaTags || '';
                const doc = new DOMParser().parseFromString(htmlString, 'text/html');
                const tags = Array.from(doc.head.children);
                setMetaTags(tags);
            } catch (err) {
                console.error("Failed to fetch meta tags for Terms and Conditions page", err);
            }
        };

        fetchMetaTags();
    }, []);

    const getMetaContent = (attr, value) => {
        const tag = metaTags.find(t => t.getAttribute(attr) === value);
        return tag?.getAttribute('content') || '';
    };

    return (
        <>
            <Helmet>
                <title>Terms and Conditions - StreamPlay Network</title>

                {/* General Meta Tags */}
                <meta name="title" content={getMetaContent('name', 'title')} />
                <meta name="description" content={getMetaContent('name', 'description')} />
                <meta name="keywords" content={getMetaContent('name', 'keywords')} />
                <link rel="canonical" href={window.location.href} />

                {/* Open Graph Meta Tags */}
                <meta property="og:type" content={getMetaContent('property', 'og:type')} />
                <meta property="og:url" content={getMetaContent('property', 'og:url')} />
                <meta property="og:title" content={getMetaContent('property', 'og:title')} />
                <meta property="og:description" content={getMetaContent('property', 'og:description')} />
                <meta property="og:image" content={getMetaContent('property', 'og:image')} />

                {/* Twitter Meta Tags */}
                <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
                <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
                <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
                <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
                <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
            </Helmet>

            <div className="terms-container">
                <div className="terms-box">
                    <h1>Terms and Conditions</h1>
                    <p><strong>Effective Date:</strong> April 9, 2025</p>

                    <p>Welcome to <strong>StreamPlay Network</strong>! By accessing and using our knowledge-driven blogging site, you agree to the following terms and conditions. Please read them carefully.</p>

                    <h2>1. Acceptance of Terms</h2>
                    <p>By using StreamPlay Network, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, please refrain from using our website.</p>

                    <h2>2. Content Usage</h2>
                    <p>All articles on StreamPlay Network are intended for awareness, education, information, and community dialogue. Reproduction or distribution of content without permission is strictly prohibited.</p>

                    <h2>3. User Conduct</h2>
                    <p>Please respect our platform and its users. Do not use this site to:</p>
                    <ul>
                        <li>Post inappropriate, hateful, harmful, or misleading content</li>
                        <li>Engage in unlawful, unethical, or abusive behavior</li>
                        <li>Infringe on the rights of others, including intellectual property</li>
                    </ul>

                    <h2>4. Comments and Interactions</h2>
                    <p>We encourage constructive and respectful discussions. However, we reserve the right to moderate or remove comments that violate our community standards.</p>

                    <h2>5. Modifications</h2>
                    <p>We may revise these Terms at any time. It is your responsibility to check this page for updates and stay informed of any changes.</p>

                    <h2>6. Third-Party Links</h2>
                    <p>StreamPlay Network may include links to third-party resources. We do not endorse or assume responsibility for the content or policies of these external sites.</p>

                    <h2>7. Disclaimer</h2>
                    <p>The content on StreamPlay Network is intended for general information and entertainment purposes only. It should not be considered a substitute for professional advice.</p>

                    <h2>8. Contact Us</h2>
                    <p>If you have any questions or concerns regarding these Terms, please reach out to us at: <strong><a href="mailto:info@treamplaynetwork.com">info@treamplaynetwork.com</a></strong></p>
                </div>

            </div>
        </>
    );
};

export default TermsAndConditions;
